<div class="modal-header">
    <h4 class="modal-title pull-left">Change Email</h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="cancel()">
        <span aria-hidden="true">&times;</span>
    </button>
</div>

<div class="modal-body">
    <form [formGroup]="form">
        <div class="form-group mb-0">
            <input type="text" class="form-control" placeholder="Enter New Email" formControlName="email"
                [ngClass]="{ 'is-invalid': isSubmitted && f.email.errors }">
            <div *ngIf="isSubmitted && f.email.errors" class="invalid-feedback">
                <div *ngIf="f.email.errors.required">Email is required</div>
                <div *ngIf="f.email.errors.notValid">{{errorMsg}}</div>
            </div>
        </div>
      
    </form>
</div>

<div class="modal-footer">
    <div *ngIf="form.enabled">
        <button class="btn btn-light mr-2" (click)="cancel();">Cancel</button>
        <am-button (onClicked)="submitForm()" [text]="'Update'" [isLoading]="isButtonDisabled"></am-button>
    </div>
</div>